import Button from 'atoms/button';
import PropTypes from 'prop-types';
import React from 'react';


export default function PageEstablishmentCTA({ className, title, subtitle, image, buttonText, handleOnClick }) {
  return (
    <div className={ `page-establishment-cta ${className}` }>
      <div className="page-establishment-cta__image">
        <img alt="" className="page-establishment-cta__image__item" src={ image } />
      </div>
      <div className="page-establishment-cta__text">
        <div className="page-establishment-cta__text__title">
          { title }
        </div>
        <div className="page-establishment-cta__text__subtitle">
          { subtitle }
        </div>
      </div>
      { buttonText
        && (
          <div className="page-establishment-cta__cta">
            <Button
              className="-filled -action-color"
              handleOnClick={ handleOnClick }
            >
              { buttonText }
            </Button>
          </div>
        )
      }
    </div>
  );
}

PageEstablishmentCTA.defaultProps = {
  buttonText: null,
  className: '',
  handleOnClick: () => {},
  subtitle: null,
};

PageEstablishmentCTA.propTypes = {
  buttonText: PropTypes.string,
  className: PropTypes.string,
  handleOnClick: PropTypes.func,
  image: PropTypes.string.isRequired,
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  title: PropTypes.string.isRequired,
};
